module.exports = __webpack_public_path__ + "static/media/logo.cd394726.svg";